import {Component, OnInit} from '@angular/core';
import {NavController}     from '@ionic/angular';
import {DataStore}         from '@aws-amplify/datastore';
import {Router}            from '@angular/router';
import * as ApexCharts     from 'apexcharts';
import {SessionService}    from '../../services/session.service';
import {Contract}          from "../../../models";
import {ContractStatus}    from "../../enums/enums";
import {DateTime}          from "luxon";

@Component({
    selector: 'app-report',
    templateUrl: './report.page.html',
    styleUrls: ['./report.page.scss'],
})
export class ReportPage {
    profile = 'personal';
    period = 'mensile';
    bonusByPeriod: any;
    chartData = [];
    selectedChartPoint = 0;
    currentYear;
    years = [];
    totals = [];
    chart: any;

    constructor(public sessionService: SessionService,
                private router: Router, private navController: NavController) {
    }


    async ionViewDidEnter() {
        await this.renderChart();
    }

    // @todo immagino farà delle richieste asincrone al datastore
    async setChartData() {
        let contracts = await DataStore.query(Contract, c => c.status('eq', ContractStatus.ACTIVE));
        let years = [];
        this.currentYear = DateTime.now().year
        years[this.currentYear] = [];
        years[this.currentYear]["01"] = 0;
        years[this.currentYear]["02"] = 0;
        years[this.currentYear]["03"] = 0;
        years[this.currentYear]["04"] = 0;
        years[this.currentYear]["05"] = 0;
        years[this.currentYear]["06"] = 0;
        years[this.currentYear]["07"] = 0;
        years[this.currentYear]["08"] = 0;
        years[this.currentYear]["09"] = 0;
        years[this.currentYear]["10"] = 0;
        years[this.currentYear]["11"] = 0;
        years[this.currentYear]["12"] = 0;
        this.totals[this.currentYear] = 0;
        for (const contract of contracts) {
            let y = contract.startDate.slice(0, 4);
            let m = contract.startDate.slice(5, 7)
            if (!years[y]) {
                years[y] = [];
                years[y]["01"] = 0;
                years[y]["02"] = 0;
                years[y]["03"] = 0;
                years[y]["04"] = 0;
                years[y]["05"] = 0;
                years[y]["06"] = 0;
                years[y]["07"] = 0;
                years[y]["08"] = 0;
                years[y]["09"] = 0;
                years[y]["10"] = 0;
                years[y]["11"] = 0;
                years[y]["12"] = 0;
            }
            if (!this.totals[y]) {
                this.totals[y] = 0;
            }

            years[y][m] = years[y][m] + contract.amount;
            this.totals[y] = this.totals[y] + contract.amount;
        }

        for (const [year, values] of Object.entries(years)) {
            this.years.push(year);
            this.chartData[year] = [];
            this.chartData[year] = [[
                values["01"],
                values["02"],
                values["03"],
                values["04"],
                values["05"],
                values["06"],
                values["07"],
                values["08"],
                values["09"],
                values["10"],
                values["11"],
                values["12"],]
            ]

        }
        this.years = this.years.sort((a, b) => a - b);

        // this.currentYear = currentYear.getFullYear()
        this.selectedChartPoint = this.chartData[this.currentYear][0][0];
    }

    // utilità per formattare le series del grafico nel modo corretto
    getFormattedSeries() {
        const series = [];
        this.chartData[this.currentYear].forEach((arr) => {
            series.push({
                name: 'Fatturato',
                data: arr,
            });
        });

        return series;
    }

    // crea effettivamente il grafico
    async renderChart() {
        await this.setChartData();

        const series = this.getFormattedSeries();

        var options = {
            chart: {
                toolbar: {
                    show: false,
                },
                // background: "#fff",
                foreColor: '#fff',
                type: 'area',
                height: '300px',
                events: {
                    markerClick: (event, chartContext, config) => {
                        this.selectedChartPoint =
                                this.chartData[this.currentYear][config.seriesIndex][
                                        config.dataPointIndex
                                        ];
                    },
                },
            },
            series: series,
            yaxis: {
                labels: {
                    formatter: (val: number) => {
                        if (val) return Math.round(val).toString().slice(0, -3) + 'K';
                        else return '0K';
                    },
                },
            },
            xaxis: {
                categories: [
                    'gen',
                    'feb',
                    'mar',
                    'apr',
                    'mag',
                    'giu',
                    'lug',
                    'ago',
                    'set',
                    'ott',
                    'nov',
                    'dic',
                ],
            },
            dataLabels: {enabled: false},
            legend: {show: false},
            stroke: {
                curve: 'straight',
                width: 1,
            },
            markers: {
                size: [2],
            },
            tooltip: {
                theme: 'dark',
                style: {
                    color: '#222',
                },
            },
            // theme: {
            //   palette: "palette3",
            // },
        };

        this.chart = await new ApexCharts(document.querySelector('#chart-cnt'), options);

        await this.chart.render();
        this.currentYear = 2023;

        this.changeYear({target: {value: this.currentYear}})
    }

    // select che cambia anno
    changeYear(event) {
        this.currentYear = event.target.value;

        this.chart.updateSeries(this.getFormattedSeries());
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    back() {
        this.navController.back();
    }
}
